import * as yup from "yup";

export const RegisterSchema = yup.object().shape({
  firstName: yup.string().required("First Name is required"),
  // Name: yup.string().required(" Name is required"),
  lastName: yup.string(),
  // role: yup.string().notOneOf([""], "You must select an option!"),
  email: yup
    .string()
    .email("Please enter valid email")
    .required("Email is required"),
  phoneNumber: yup.string().required("Phone number is required"),
  verifyPassword: yup
    .string()
    .required("Password must match")
    .oneOf([yup.ref("password"), null], "Passwords must match"),
  password: yup
    .string()
    .required("Password is required")
    .matches(
      /^(.{0,16}|[^0-9]*|[^A-Z]*|[^a-z]*|[a-zA-Z0-9]*)$/,
      "Password must be alpa numeric"
    ),
  // companyName: yup.string().required("Company name is required"),
  // jobDescription: yup.string().required("Please add Description"),
});

export const LoginSchema = yup
  .object()
  .shape({
    email: yup
      .string()
      .email("Please enter valid email")
      .required("Email is required"),
    password: yup.string().required("Password is required"),
  })
  .required();

export const ResetPasswordSchema = yup.object({
  email: yup
    .string()
    .email("Please enter valid email")
    .required("Email is required"),
});


export const UpdateDeveloperProfileSchema = yup.object().shape({
  // Name: yup.string().required(" Name is required"),
  // email: yup
  //   .string()
  //   .email("Please enter valid email")
  //   .required("Email is required"),
  // country:yup.string().required("Country is required"),
  experience:yup.string().required("Experience is required"),
  streetAddres:yup.string().required("Street addresss is required"),
  // month: yup.string().notOneOf([""], "You must select an option!"),
  jobRole:yup.string().required("Job role addresss is required"),
  jobDescription:yup.string().required("Job role addresss is required"),
 
  // companyName: yup.string().required("Company name is required"),
  // jobDescription: yup.string().required("Please add Description"),
});




export const UpdateClientProfileSchema = yup.object().shape({
  Name: yup.string().required(" Name is required"),
  email: yup
    .string()
    .email("Please enter valid email")
    .required("Email is required"),
  phoneNumber: yup.string().required("Phone number is required"),
  // companyName: yup.string().required("Company name is required"),
  jobDescription: yup.string().required("Please add Description"),
});
